import apiClient from './client';
import type {
  ProviderFinanceDashboard,
  ProviderFinanceRange,
  ProviderFinanceSyncRequest,
  ProviderFinanceSyncResponse,
} from '@/types/providerFinance';

export const providerFinanceApi = {
  getDashboard: (range: ProviderFinanceRange) =>
    apiClient
      .get<ProviderFinanceDashboard>('/provider-finance/dashboard', { params: { range } })
      .then((r) => r.data),

  triggerSync: (payload: ProviderFinanceSyncRequest = {}) =>
    apiClient
      .post<ProviderFinanceSyncResponse>('/provider-finance/sync', payload)
      .then((r) => r.data),
};
